import { useState } from 'react';
import { Form } from '@radix-ui/react-form';
import { Button, TextField } from '@radix-ui/themes';

import { redirectTo } from '../../../utils/CommonUtil';
import { getCookie } from '../../../utils/CookieUtil';
import { ADMIN_RECOMMENDED_POSTS_ADDRESS } from '../../../utils/PageAddressUtil';
import RequestUtil from '../../../utils/APIRequestUtil';

export default function AdminRecommendedPostAdd() {
    const [formData, setFormData] = useState({});
    const [error, setError] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const recommend = async (e) => {
        e.preventDefault();

        const resp = await RequestUtil.post('/api/admin/recommended-posts', JSON.stringify(formData), {
            'Content-Type': 'application/json',
            'username': getCookie('username'),
            'sessionId': getCookie('sessionId')
        });

        if (resp.status != 201) {
            const respBody = await resp.json();
            setError(respBody);
        } else {
            redirectTo(ADMIN_RECOMMENDED_POSTS_ADDRESS);
        }
    }

    return (
        <Form onSubmit={recommend}>
            <div className="redesign-form-field">
                <label className="redesign-form-label" htmlFor="link">文章链接 *</label>
                <TextField.Root name="link" id="link" onChange={handleChange} />
                {error ? <span style={{ color: '#c62828', fontSize: 13 }}>{error.message}</span> : null}
            </div>

            <Button type="submit" className="redesign-btn-primary" style={{ marginTop: 8 }}>
                提交
            </Button>
        </Form>
    )
}
